import { useGetReceiveReleaseLookupsQuery, type ReceiveReleaseLookupField } from '@/entities/receive';
import { useDebounce, useProjectSiteParams } from '@/shared/lib';

const EMPTY: string[] = [];

/** Suggestions for a free-text handover field, searched on the server as the operator types. */
export const useReleaseLookups = (field: ReceiveReleaseLookupField, query: string): string[] => {
  const { projectId, siteId } = useProjectSiteParams();
  const q = useDebounce(query.trim(), 300);

  const { data } = useGetReceiveReleaseLookupsQuery(
    { field, q: q || undefined, projectId, siteId },
    { skip: !projectId || !siteId }
  );

  return data ?? EMPTY;
};
